<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; position: relative;">
  <div style="display: flex; flex-direction: column; width: 100%; max-width: 1080px;"> 
      <div class="{{isDesktop?'saludo-container':'saludo-containerMovil'}} "   >
      
          <p class="col-12 col-xl-8 col-lg-8 col-md-8 w-100" style="font-size: 16px; margin-bottom: 24px; text-align: center;">{{greetings}} <b>{{getUser()}}</b>, dispones de los siguientes accesos</p>
          
      </div>
      <div class="row">

          <div *ngFor="let card of cards" (click)="irA(card.url)" class="col-xl-4 col-lg-6">
              <div class="widget widget-stats" [style.background]="card.background" (click)="irA(card.url)" style="cursor: pointer;">
                  <div class="stats-icon stats-icon-lg custom-fs"><i class="fa {{card.icon}} fa-fw"></i></div>
                  <div class="stats-content">
                      <div class="stats-title">{{card.title}}</div>
                      <div class="stats-number"  style="font-size: 19px;">{{card.subtitle}}</div>
                      <div class="">
                          <!-- <div class="stats-desc">{{card.title}} - {{card.subtitle}}</div> -->
                          <a style="cursor: pointer;" (click)="irA(card.url)">Ir <i class="fa fa-arrow-alt-circle-right"></i></a>
                      </div>                        
                  </div>
              </div>
          </div>

      </div>
  </div>
</div>